module.exports = __webpack_public_path__ + "static/emanagement5-a163544af367068dfb892e9a4bee9104.png";